import apiClient from "../../axios/apiClient";


export const getUserList =
  (token, limit = 10, page = 1, search = "", sort = "desc",status) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERLIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/users`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            status,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_USERLIST_FULFILLED",
        payload: response.data?.data,
        userCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_USERLIST_REJECTED",
        payload: error.response,
      });
    }
  };

// export const getInactiveUserList =
//   (token, limit = 10, page = 1, search = "", sort = "desc" , type="inactive") =>
//   async (dispatch) => {
//     try {
//       dispatch({ type: "GET_INACTIVEUSERLIST_PENDING" });

//       const response = await apiClient.get(
//         `/api/v1/users`,
//         {
//           params: {
//             limit: limit,
//             page: page,
//             search: search,
//             sort: sort,
//             status,
//           },
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       dispatch({
//         type: "GET_INACTIVEUSERLIST_FULFILLED",
//         payload: response.data?.data,
//         userCount: response.data?.count,
//         permissions: response.data?.permissions,
//       });
//     } catch (error) {
//       dispatch({
//         type: "GET_INACTIVEUSERLIST_REJECTED",
//         payload: error.response,
//       });
//     }
//   };



  export const saveUserData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_USER_PENDING" });
  
      const response = await apiClient.post(
        `/api/v1/users`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_USER_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_USER_REJECTED", payload: error.response });
    }
  };
  

  export const getUserListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/users/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_USERLISTBYID_FULFILLED",
        payload: response.data?.data,
        userCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_USERLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateUserData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_USER_PENDING" });

    const response = await apiClient.put(
      `/api/v1/users/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_USER_REJECTED", payload: error.response });
  }
};


export const deleteUserData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_USER_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/users/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_USER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_USER_REJECTED", payload: error.response });
  }
};


export const logoutUserDevice =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "LOGOUT_USER_DEVICE_PENDING" });
      const data={
        "status":"Active"
      }
      const response = await apiClient.post(
        `/api/admin/v1/Logout-User/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "LOGOUT_USER_DEVICE_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "LOGOUT_USER_DEVICE_REJECTED",
        payload: error.response,
      });
    }
  };


  export const uploadUserPhoto = (token, id, photo) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_USER_PHOTO_PENDING" });
      const formData = new FormData();
      formData.append("file", photo);
      const response = await apiClient.post(
        `/api/v1/users/${id}/photo`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      dispatch({ type: "ADD_USER_PHOTO_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "RESET_USER_PHOTO_REJECTED", payload: error.response });
    }
  };

  export  const updateUserRegistrationStatus = (token, id) => async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_USER_REGISTRATION_STATUS_PENDING" });
      const data = { isRegistration: false };
      const response = await apiClient.post(
        `/api/v1/users/${id}/reset-registration`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USER_REGISTRATION_STATUS_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "UPDATE_USER_REGISTRATION_STATUS_REJECTED", payload: error.response });
    }
  };